import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import { columnsTemplate } from '@features/eventList/components/EventCard/styles';
import { textSmall } from '@features/ui/styles/textStyles';

interface HeaderProps {
    className?: string;
}

const Header = ({ className }: HeaderProps) => {
  const { t } = useTranslation();
  return (
    <Container className={className}>
      <div className="EventCard_HeaderName">{t('eventCard_headerName.message')}</div>
      <div className="EventCard_HeaderDate">{t('eventCard_headerDate.message')}</div>
      <div className="EventCard_HeaderLocation">{t('eventCard_headerLocation.message')}</div>
      <div className="EventCard_HeaderSport">{t('eventCard_headerSport.message')}</div>
    </Container>
  );
};

export default Header;

const Container = styled.div`
    display: grid;
    ${columnsTemplate};
    padding: 0px 20px;

    grid-template-areas: ". name date location sport";
    grid-column-gap: 20px;

    > div {
        color: var(--color-grey3);
        text-transform: uppercase;
        ${textSmall};
    }

    .EventCard_HeaderName {
        grid-area: name;
    }

    .EventCard_HeaderDate {
        grid-area: date;
    }

    .EventCard_HeaderLocation {
        grid-area: location;
    }

    .EventCard_HeaderSport {
        grid-area: sport;
    }
`;
